"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomInRange = void 0;
/**
 * Creates a random number within a range.
 *
 * @param range   [Minimum, maximum] numbers in a range.
 * @returns Random number within the [minimum, maximum] range.
 */
exports.randomInRange = (range) => typeof range === "number"
    ? range
    : Math.floor(Math.random() * (range.max - range.min + 1)) + range.min;
